// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HEQpc","modal":"Modal_modal__Pjdnu","slide-down":"Modal_slide-down__bxmu9"};